var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector__controls"},[_c('button',{staticClass:"selector__control",on:{"click":_vm.clearFilters}},[_c('img',{attrs:{"src":require("@/assets/images/icons/cross-primary.svg"),"alt":"cross icon"}}),_vm._v(" Clear ")]),_c('button',{staticClass:"selector__control",on:{"click":_vm.applyFilters}},[_vm._v(" Apply ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }